import SearchBar from './SearchBar'

export * from './SearchBar'

export default SearchBar
